export default __webpack_public_path__ + "static/inteligenciaArtificial-35689187e648ca1bc74880d97bc47363.svg";